import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-second-hand-search',
  templateUrl: './second-hand-search.component.html',
  styleUrls: ['./second-hand-search.component.scss'],
})
export class SecondHandSearchComponent {
  @Input() color;
  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  @Output() onSearchChange = new EventEmitter<string>();

  toolbarData = {
    arrowRouter: '/bazaar',
    title: 'Second Hand',
  };

  constructor() {}

  searchItem(event) {
    this.onSearchChange.emit(event.target.value);
  }
}
